import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  btn: {
    padding: '8px 22px',
    backgroundColor: '#CD0021',
    color: '#ffffff',
    fontWeight: 700,
    fontSize: '15px',
    lineHeight: '26px',
    height: '51px',
    textAlign: 'center',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    position: 'relative',
    maxWidth: '210px',
    width: '100%',
    borderRadius: '25px',
    marginRight: '1rem',
    '&:disabled': {
      color: 'rgba(0, 0, 0, 0.26)',
      boxShadow: 'none',
      backgroundColor: 'rgba(0, 0, 0, 0.12)',
      '& svg': {
        filter: 'invert(97%) sepia(0%) saturate(2219%) hue-rotate(18deg) brightness(79%) contrast(102%)',
        opacity: 0.2,
      },
    },
    '& svg': {
      position: 'absolute',
      top: '50%',
      right: '38px',
      transform: ' translateY(-50%)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '8px 22px',
      fontSize: '15px',
      lineHeight: '26px',
      '& svg': {
        right: '50px',
      },
      marginBottom: '1rem',
    },
  },
}));

export default useStyles;
